import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import classNames from "classnames";
import { Flipper } from "react-flip-toolkit";

import {emptyVehicle, emptyCategory} from '../actions';
import LicencePlateBox from './LicencePlateBox';
import VehicleSelectionBox from "./VehicleSelectionBox";
import PartNameBox from "./PartNameBox";
import PartReferenceBox from "./PartReferenceBox";
import VehicleInformationBox from "./VehicleInformationBox";
import CategoryInformationBox from "./CategoryInformationBox";
import MobileButton from "../components/MobileButton";

const boxes = [
        {Component: VehicleInformationBox, vehicle:true, category:null, hideConst:[]},
        {Component: CategoryInformationBox, vehicle:null, category:true},
        {Component: LicencePlateBox, vehicle:false, category:null},
        {Component: VehicleSelectionBox, vehicle:false, category:null},
        {Component: PartNameBox, vehicle:null, category:false},
        {Component: PartReferenceBox, vehicle:null, category:null},
    ];

class App extends Component{
    constructor(props) {
        super(props);
        let currentLocation =  document.location.href.substring( 0 ,document.location.href.lastIndexOf( "?" ) ).split("/");
        let activeTab='';
        if(currentLocation[currentLocation.length-1]=="recherche-piece"){
            activeTab='part_reference';
        }else activeTab=!props.vehicle.type.id ? props.vehicle.modelGroup.id? 'vehicle_selection':'licence_plate' : 'part_name';
        this.state = {
          activeTab:activeTab ,
          blink: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.vehicle.type.id !== prevProps.vehicle.type.id) {
            if (this.props.vehicle.type.id && (this.state.activeTab === 'licence_plate' || this.state.activeTab === 'vehicle_selection')) {
                this.setState({activeTab : 'part_name'});
            }

            if (!this.props.vehicle.type.id) {
                this.setState({activeTab : 'licence_plate'});
            }
            this.activeBlink();
        }

        if (this.props.category !== prevProps.category) {
            if (this.props.category && (this.state.activeTab === 'part_name' || this.state.activeTab === 'part_reference')) {
                this.setState({activeTab : 'licence_plate'});
            }

            if (!this.props.category.id) {
                this.setState({activeTab : 'part_name'});
            }
            this.activeBlink();
        }
    }

    handleVehicleResetAction() {
        this.props.emptyVehicle();
    }

    handleCategoryResetAction() {
        this.props.emptyCategory();
    }

    handleTabChange(activeTab) {
        this.setState({activeTab:activeTab});
    }

    activeBlink() {
        this.setState({blink:!this.props.category.id !== !this.props.vehicle.type.id});
    }

    render() {
        return (
            <div className='search_form_container'>
                <div className="button_container">
                    {!this.props.vehicle.type.id ?
                        <MobileButton type={"vehicle"} name={"licence_plate"} description={"Immatriculation"} activeTab={this.state.activeTab} completed={this.props.vehicle.type.id} clickAction={this.handleTabChange.bind(this)}/>
                    : null}
                    {!this.props.vehicle.type.id ?
                        <MobileButton type={"vehicle"} name={"vehicle_selection"} description={"Modèle du vehicule"} activeTab={this.state.activeTab} completed={this.props.vehicle.type.id} clickAction={this.handleTabChange.bind(this)}/>
                    :null}
                    {this.props.vehicle.type.id
                        ?
                        <div className="tab_information" id="vehicle_information">
                            <div>
                                <p>{this.props.vehicle.brand.name} {this.props.vehicle.model.name} <br/> {this.props.vehicle.type.name}</p>
                            </div>
                            {this.props.vehicle.licencePlate
                                ? <div><p>{this.props.vehicle.licencePlate}</p></div>
                                : null
                            }
                            <div>
                                <button onClick={() => this.handleVehicleResetAction()}>Changer de véhicule</button>
                            </div>
                        </div>
                    : null}
                    {this.props.category.id && !CATEGORY_PAGE
                        ?
                        <div className="tab_information" id="category_information">
                            <div>
                                <p>Catégorie sélectionné :</p>
                            </div>
                            <div>
                                <p>{this.props.category.name}</p>
                            </div>
                            <div>
                                <button onClick={() => this.handleCategoryResetAction()}>Changer de catégorie</button>
                            </div>
                        </div>
                    : null}
                    {!this.props.category.id || (this.props.category.id && CATEGORY_PAGE && !!this.props.vehicle.type.id) ?
                        <MobileButton type={"part"} name={"part_name"} description={"Nom de la pièce"} activeTab={this.state.activeTab} completed={this.props.category.id} clickAction={this.handleTabChange.bind(this)}/>
                    :null}
                    <MobileButton type={"part"} name={"part_reference"} description={"Reference"} activeTab={this.state.activeTab} completed={this.props.category.id} clickAction={this.handleTabChange.bind(this)}/>
                </div>
                <Flipper flipKey={`${this.props.vehicle.type.id}-${this.props.category.id}`} element="main">
                    <div className='box_container'>
                        {boxes.filter(function (box){
                            if (CATEGORY_PAGE === true && box.category === false && !this.props.vehicle.type.id) {
                                return false;
                            }
                            if (null !== box.vehicle) {
                                if (FORCE_FORM_DISPLAY === 'vehicle') {
                                    return !box.vehicle;
                                }
                                return !!this.props.vehicle.type.id === box.vehicle;
                            }

                            if (null !== box.category) {
                                if (FORCE_FORM_DISPLAY === 'category') {
                                    return !box.category;
                                }
                                return !!this.props.category.id === box.category;
                            }
                            return true;
                        }.bind(this)).map(function(box, index) {
                            return (
                                <box.Component key={index} activeTab={this.state.activeTab}/>
                            )
                        }.bind(this))}
                    </div>
                </Flipper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vehicle:state.vehicle,
        category:state.category,
        redirect:state.redirect
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        emptyVehicle,
        emptyCategory
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App)